#udp-line-chart{
    height: 500px;
    width: 500px;
    z-index: 1000;
}